
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/epices",
      function () {
        return require("private-next-pages/epices/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/epices"])
      });
    }
  